import shallowequal from "shallowequal"
import { createHashHistory as createHistory } from "history"

import i18n from "@cirrus/legacy/features/core/shared/utils/i18n.es6"
import alt from "@cirrus/legacy/app-author/alt/alt.es6"

import { confirmationResult } from "@cirrus/legacy/app-common/alt/framework/confirmationDialogV2/constants.es6"
import actionListener from "@cirrus/legacy/app-author/alt/actionListener.es6"
import applicationConfirmationActions from "@cirrus/legacy/app-author/alt/application/application/children/confirmation/actions/actions.es6"

import { getRouteDataFromPathname } from "./alt/selectors/routeDataSelectorFactory.jsx"
import { routeDataSelector } from "./alt/exports.jsx"

const isBrowserUrlMatch = () => {
  let appState = alt.getStore("ApplicationStore").getState()
  let storedRouteData = routeDataSelector(appState)
  let currentLocationRouteData = getRouteDataFromPathname(window.location.hash.replace("#", ""))

  return (
    storedRouteData.route.id === currentLocationRouteData.route.id &&
    shallowequal(storedRouteData.match.params, currentLocationRouteData.match.params)
  )
}

export const history = createHistory({
  getUserConfirmation: (message, callback) => {
    actionListener.addActionListenerOnce(applicationConfirmationActions.SUBMITTED, (result) => {
      if (result === confirmationResult.confirmed) {
        callback(true)
      } else {
        callback(false)

        setTimeout(() => {
          if (!isBrowserUrlMatch()) {
            let appState = alt.getStore("ApplicationStore").getState().toJS()

            window.location.hash = `${appState.router.location.pathname}${appState.router.location.search}`
          }
        })
      }
    })

    applicationConfirmationActions.show({
      header: i18n("General:Warning"),
      text: i18n("General:ConfirmLeaveWithoutSave"),
      contentWidth: "500px",
    })
  },
})

